import React from 'react';
import '../../scss/footer.scss';

export default function Footer() {
    return <div className="footer">
        Developed by Rasif Sahl.....
    </div>
}